<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item 
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="data[name]" hidden="hidden">
            <div class="member-select-pane el-input el-input--default selectItem-Button" :class="disabled ? 'is-disabled' : ''" @click="showSelectZone">
                <el-icon><circle-plus /></el-icon> <span style="margin-left:5px">{{ buttonName }}</span>
            </div>
            <div class="top8 member-select-pane el-input el-input--default well-warpper" v-if="selfSetting.IsShowValue" v-show="selectItems.length > 0">
                <div class="well"
                    v-if="selectItems.length > 0"  
                    @click="showFormDetial(selectItems[0].ContentItemId)">
                    <div class="well-box">
                        <div class="well-content">
                            <div class="field" v-for="(field,index) in displayFields"
                                :key="index">
                                {{ selectItems[0][field] }}
                            </div>
                        </div>
                        <el-icon class="well-delete" color="#F56C6C" @click.stop="deleteItem"><delete /></el-icon>
                    </div>
                </div>
            </div>
            <div class="top8 member-select-pane el-input el-input--default" v-if="selfSetting.IsShowValue" v-show="selectItems.length == 0">
                暂未选择数据
            </div>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
        <el-dialog
            lock-scroll
            top="10vh"
            class="contentPickerDetail"
            append-to-body
            v-model="visibleState"
            title="数据详情"
            width="70%">
            <qweForm isPropMode
                    :propDatas="propDatas"
                    :display="true"
                    :is-show-head="false"></qweForm>
        </el-dialog>
        <el-dialog
            destroy-on-close
            lock-scroll
            fullscreen
            class="grid-picker"
            append-to-body
            v-model="gridState"
            :title="buttonName">
            <qweGrid 
                @SelectChange="selectEvent"
                isPropMode
                isSingleSelect
                :propDatas="filters"
                :gridId="gridId">
            </qweGrid>
            <template #footer>
                <el-button type="success" @click="sumbit">确认</el-button>
                <el-button  @click="gridState = false">取消</el-button>
            </template>
        </el-dialog>
    </el-col>
</template>

<style>
    .contentPickerDetail{
        height: 80% !important;
    }
    .top8{
        margin-top: 8px;
    }
</style>

<script>
    import QweForm from "../../Form/FormItem.vue"
    import CorrelationField from "./BaseCorrelationField"
    import { CirclePlus, Delete } from '@element-plus/icons-vue'
    import qweGrid from "../../Grid/GridItem.vue"

    export default {
        name:"CorrelationField",
        mixins:[CorrelationField],
        components:{
            "qweForm":QweForm,
            "circle-plus":CirclePlus,
            "qweGrid":qweGrid,
            "delete":Delete
        }
    }
</script>